module.exports = __webpack_public_path__ + "components/flag/static/square/bf-582b0d035b35d9bcee1592523979cf0f.svg";